'use es6';

import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
export function getIsLimitedAccessRangeType(dateRage) {
  if (dateRage) {
    const rangeType = ImmutableMap.isMap(dateRage) ? dateRage.get('rangeType') : dateRage.rangeType;
    if (rangeType) {
      return ['ALL', 'THIS_DAY', 'LAST_DAY'].includes(rangeType);
    }
  }
  return false;
}
export function getIsLimitedAccessStartDate(dateRage) {
  if (dateRage) {
    const startDate = ImmutableMap.isMap(dateRage) ? dateRage.get('startDate') : dateRage.startDate;
    if (startDate) {
      return I18n.moment(startDate).isBefore(I18n.moment().subtract(3, 'years'));
    }
  }
  return false;
}